if (typeof lfQA === 'undefined') {
  function lfQA(btn, variantId, event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    if (btn.disabled || btn.dataset.lfBusy) return;
    btn.dataset.lfBusy = '1';

    var isMobile = btn.classList.contains('lf-qa-mobile');
    var orig = btn.innerHTML;
    if (isMobile) { btn.style.opacity = '0.5'; }
    else { btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Bezig...'; }

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionIds = ['cart-drawer'];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try { sectionIds = cartDrawer.getSectionsToRender().map(function(s){ return s.id; }); } catch (e) {}
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: sectionIds, sections_url: window.location.pathname })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.classList.add('lf-added');
      btn.style.opacity = '';
      if (isMobile) {
        btn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
      } else {
        btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Toegevoegd!';
      }

      // is-empty stand verwijderen zodat de lay-out normaal wordt
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        var cdItems = cartDrawer.querySelector('cart-drawer-items');
        if (cdItems) { cdItems.classList.remove('is-empty'); }
      }

      // Shopify's eigen renderContents: ververst drawer + telbubbel én opent de drawer
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        try {
          cartDrawer.renderContents(data);
        } catch (e) {
          if (typeof cartDrawer.open === 'function') { cartDrawer.open(btn); }
        }
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open(btn);
      }

      // Na render nogmaals is-empty weghalen (renderContents kan de class terugzetten)
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        var cdItems2 = cartDrawer.querySelector('cart-drawer-items');
        if (cdItems2) { cdItems2.classList.remove('is-empty'); }
      }

      setTimeout(function() {
        btn.innerHTML = orig;
        btn.classList.remove('lf-added');
        btn.style.opacity = '';
        delete btn.dataset.lfBusy;
      }, 2000);
    })
    .catch(function() {
      btn.innerHTML = orig;
      btn.style.opacity = '';
      delete btn.dataset.lfBusy;
    });
  }
}
